import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-summary-header',
	templateUrl: './summary-header.component.html',
	styleUrls: ['./summary-header.component.css']
})
export class SummaryHeaderComponent {
	@Input() siteInfo!: any;
	@Input() totalDevices: number = 0;
	@Input() period: string = '';
	@Input() selectedPeriod: string = '';
}
